import React from 'react';
import { StyledIconButton } from '../../styles/matieralui/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { FullUI } from '../../redux/UI/ui.selectors';
import { useDispatch } from 'react-redux';
import { toggleDrawer } from '../../redux/UI/ui.actions';
import { respondTo } from '../../styles/Theme';
import styled, { css } from 'styled-components';

const StyledMobileTrigger = styled(StyledIconButton)`
    display: none !important;
    ${respondTo('mobile', css`display:inline-flex !important;`)}
`

export const MobileTrigger = () => {
    const dispatch = useDispatch();
    const ui = FullUI();
    const open = (!ui.drawer) ? false : ui.drawer.open;
    const handleMobileOpen = (e) => {

        if (open === true) {
            dispatch(toggleDrawer(false, true))
        } else {
            dispatch(toggleDrawer(true, true))
        }
    }
    return (
        <StyledMobileTrigger onClick={handleMobileOpen}>
            {!open && (<MenuIcon />)}
            {open && (<CloseOutlinedIcon />)}
        </StyledMobileTrigger>

    )
}